import React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useImageAttribution } from './hooks/useImageAttribution';

export const ImageWithAttribution: React.FC<{ imgAlt: string }> = ({ imgAlt }) => {
	const {
		data: { largePhotoUrl: imgHref, credit, license, platform, source },
	} = useImageAttribution();

	if (!imgHref || !credit || !source) {
		return null;
	}

	return (
		<div className="z-0 h-[242px] md:h-full xl:h-[400px]">
			<div className="relative h-full w-full">
				<Image className="h-full w-full object-cover" src={imgHref} alt={imgAlt} />
				<Text
					variant="body"
					className="absolute bottom-11 left-4 right-4 z-10 w-auto !text-xs text-typography-inverse-strong md:bottom-2"
				>
					<AttributionContent platform={platform} license={license} source={source} credit={credit} />
				</Text>
				<div className="absolute bottom-0 z-0 h-2/3 w-full bg-[linear-gradient(180deg,rgba(58,41,62,0.00)_0%,rgba(58,41,62,0.30)_100%)]" />
			</div>
		</div>
	);
};

function AttributionContent({
	platform,
	license,
	source,
	credit,
}: {
	platform: string | null | undefined;
	license: string | null | undefined;
	source: string;
	credit: string;
}) {
	const { translateHtml } = useI18n();
	if (platform === 'shutterstock') {
		return translateHtml('corgi.topic_page.page_heading.image_attribution.with_shutterstock', {
			sourceHref: source,
			credit,
			shutterstockHref: 'https://www.shutterstock.com/',
		});
	}
	if (license) {
		return translateHtml('corgi.topic_page.page_heading.image_attribution.with_license', {
			sourceHref: source,
			credit,
			license,
		});
	}
	return translateHtml('corgi.topic_page.page_heading.image_attribution.basic', { sourceHref: source, credit });
}
